import React from 'react';
import { Button } from 'antd';
import { useNavigate } from '@common/hooks';
import { ButtonGroup, Gap, Icon, Modal, Text } from '@common/components';
import { useComplianceItemAction } from '@onboarding/hooks';
import { buildDialogUrl } from '@common/services';

export function ComplianceItemActionsAcceptReject({
  complianceItemId,
  complianceItemState,
  complianceItemHasAnyFile,
  onFinished,
}: {
  complianceItemId: string;
  complianceItemState: string;
  complianceItemHasAnyFile: boolean;
  onFinished: () => void;
}) {
  const navigate = useNavigate();

  const [performAction, { loading }] = useComplianceItemAction({
    onFinished,
  });

  const isApproved = complianceItemState === 'approved';
  const isRejected = complianceItemState === 'rejected';

  function approveItem() {
    performAction({
      variables: {
        id: complianceItemId,
        input: {
          action: 'approve',
        },
      },
    });
  }

  function onAccept() {
    if (isRejected) {
      Modal.confirm({
        title: 'Are you sure you want to approve this compliance item?',
        content: (
          <Gap vertical size="lg">
            <Text>You&apos;re switching this items status.</Text>

            <Text>
              Rejected <Icon size="sm" icon="arrowRight" kind="regular" />{' '}
              Approved.
            </Text>
          </Gap>
        ),
        okText: 'Yes, Approve',
        cancelText: 'Cancel',
        onOk: approveItem,
      });

      return;
    }

    approveItem();
  }

  function openRejectionDrawer() {
    const rejectionDrawerUrl = buildDialogUrl(
      'compliance-item-rejection-drawer',
      {
        overlap: true,
        props: {
          complianceItemId,
        },
      }
    );

    navigate(rejectionDrawerUrl);
  }

  return (
    <ButtonGroup>
      <Button
        size="large"
        danger
        disabled={isRejected || !complianceItemHasAnyFile}
        onClick={openRejectionDrawer}
      >
        Reject
      </Button>
      <Button
        size="large"
        type="primary"
        loading={loading}
        disabled={isApproved || !complianceItemHasAnyFile}
        onClick={onAccept}
      >
        Approve
      </Button>
    </ButtonGroup>
  );
}
